<ng-content></ng-content>

@switch (mode) {
  @case ('addModal') {
    <button mat-flat-button (click)="openAddressModal()">
      <mat-icon>add</mat-icon>Add Mailing Address
    </button>
  }
  @case ('editModal') {
    <div
      fxLayoutAlign="space-between start"
      class="has-address"
      [class.isInvalid]="addressHelper?.isInvalid"
    >
      <read-only-address
        [address]="addressHelper?.address"
        [hideStatus]="!staffCanValidate"
      ></read-only-address>
      <div>
        <button
          mat-icon-button
          color="primary"
          aria-label="Edit address"
          (click)="openAddressModal()"
        >
          <mat-icon>edit</mat-icon>
        </button>
        <button
          mat-icon-button
          color="primary"
          aria-label="Delete address"
          (click)="confirmDialog.open()"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>
  }
  @case ('inline') {
    <address-editor class="mt-1" [address]="addressHelper"></address-editor>
  }
}

<lib-dialog
  #confirmDialog="dialog"
  (yes)="clearAddress()"
  header="Remove Mailing Address"
  yesText="Remove"
  [width]="300"
>
  <ng-template
    >Are you sure you want to remove the mailing address?</ng-template
  >
</lib-dialog>
<!--edit address modal-->
<lib-dialog
  (no)="cancelEditAddress()"
  [onOkay]="onOkay"
  #addressDialog="dialog"
  [header]="hasAddress ? 'Update Address' : 'Add Address'"
  [yesText]="
    (hasAddress ? 'Update ' : 'Add ') +
    (staffCanValidate && isStaff ? 'and Verify' : 'Address')
  "
  [isAffirmativeBasicColor]="staffCanValidate && isStaff"
  [form]="addressHelper?.addressFormGroup"
>
  <ng-template>
    <address-editor [address]="addressHelper"></address-editor>
  </ng-template>

  <ng-template #extraButtons let-clickClose let-isSaving="isSaving">
    @if (staffCanValidate && isStaff) {
      <button
        mat-flat-button
        color="primary"
        [disabled]="isSaving"
        (click)="saveWithoutValidate(clickClose)"
      >
        {{ hasAddress ? 'Update' : 'Add' }} Address
      </button>
    }
  </ng-template>
</lib-dialog>

<!--address had error modal. correctedAddress or !correctedAddress-->
<app-address-warning-dialog
  (useAddress)="useAddress($event)"
></app-address-warning-dialog>
